var lib_core = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var GroupSelectionInteractionModel = function (elements) {
    var data = "_dummy";
    lib_core.AbstractInteractionModel.call(this, data);

    this.elements = elements;
};
lib_core.inherit(GroupSelectionInteractionModel, lib_core.AbstractInteractionModel);
lib_core.JsonParser.registerClass(GroupSelectionInteractionModel, "GroupSelectionInteractionModel");

module.exports = GroupSelectionInteractionModel;

/**
 * @function getInspectorElements
 * @author Ed Pataky
 * @description this is used when multiple objects are selected and we want to see the
 *   common controls among all in the inspector
 * @returns {Array}
 */
/**
 * Cases:
 *   a) a single element is selected
 *   b) multiple elements are selected
 *   c) a single element is selected, and it has a selected subelement
 *   d) multiple elements are selected, and there is also a selected subelement
 *
 * We should show:
 *   a) we show the inspector elements for the selected element
 *   b) we show the shared elements for the multiple selected elements
 *   c) we show the inspector for the overall shape with the subelement inspector element shown first (planned to change)
 *   d) ignore the subelement
 *
 *   Note: in current selection SM implementation, selected subelement is only selected when shift is NOT pressed
 *   (example: when you click on a pad inside a pad generator)
 */
GroupSelectionInteractionModel.prototype.getInspectorElements = function() {
    var self = this;
    var inspectorElements = {help_elements:{name:"Empty"}, input_elements:[]};

    inspectorElements.help_elements.name = 'Multiple Shapes';

    this.parent().inspectorButtons.forEach(function(buttonRow) {
        var buttons = [];
        buttonRow.forEach(function(button) {
            var cEvent = new lib_core.GuiEvent(button.eventType);
            buttons.push(
                {
                    label      : "",
                    type       : ui_extensions.InspectorInputType.BUTTON,
                    cEvent     : cEvent,
                    icon       : button.style.icon
                }
            );
        });
        if(buttons.length) {
            inspectorElements.input_elements.push(
                {
                    label      : "Button Group",  // TODO
                    type       : ui_extensions.InspectorInputType.BUTTON_GROUP,
                    buttons    : buttons
                }
            );
        }
    });

    var subjectCount = this.elements.size();
    console.assert(subjectCount > 1);
    if(subjectCount <= 1) {
        return inspectorElements;
    }

    // make table of inspector elements
    var commonTable = {};
    this.elements.forEach(function(element) {
        if(element.getInspectorElements) {
            element.getInspectorElements().input_elements.forEach(function(inelement) {
                inelement = ui_extensions.InspectorInputType.convert(inelement);

                var key = inelement.label;
                if(!(key in commonTable)) {
                    commonTable[key] = inelement;
                } else {
                    commonTable[key].combineWith(inelement);
                }
            });
        }
    });

    $.each(commonTable, function(key, element) {
        if(element.times_combined == subjectCount) {
            element.finishCombination();
            inspectorElements.input_elements.push(element);
        }
    });

    return inspectorElements;
};
